import { render, staticRenderFns } from "./EdiDetailProperty.vue?vue&type=template&id=6ac2b564&scoped=true&"
import script from "./EdiDetailProperty.vue?vue&type=script&lang=js&"
export * from "./EdiDetailProperty.vue?vue&type=script&lang=js&"
import style0 from "./EdiDetailProperty.vue?vue&type=style&index=0&id=6ac2b564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2b564",
  null
  
)

export default component.exports